const toneStyles = {
  teal: "bg-teal-50 text-teal-700 ring-teal-100",
  blue: "bg-blue-50 text-blue-700 ring-blue-100",
  pink: "bg-pink-50 text-pink-700 ring-pink-100",
  yellow: "bg-amber-50 text-amber-700 ring-amber-100",
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-100",
  gray: "bg-slate-100 text-slate-600 ring-slate-200",
};

export default function VisitStatCard({ title, value, color = "teal", icon: Icon }) {
  const tone = toneStyles[color] || toneStyles.teal;

  return (
    <div className="group rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <p className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">
            {Number(value || 0).toLocaleString("th-TH")}
          </p>
        </div>
        {Icon && (
          <div className={`rounded-xl p-2.5 ring-1 ${tone}`}>
            <Icon size={20} strokeWidth={1.8} />
          </div>
        )}
      </div>
    </div>
  );
}
